import React, { useEffect, useState, useRef } from 'react';
import ReactDOM from 'react-dom';

import App from 'App';
import { Modal } from 'flowbite';

import Button from 'CommonComponents/Button';
import ModalFooter from 'CommonComponents/ModalFooter';
import ModalHeader from 'CommonComponents/ModalHeader';

export default function RecalculateTotalButton(props) {
    const [request, setRequest] = useState(false);
    const [modal, setModal] = useState(null);

    const recalculateTotalsModalEl = useRef(null);
    const MODAL_OPTIONS = {
        backdropClasses: 'tw-hidden',
    };

    useEffect(() => {
        setModal(new Modal(recalculateTotalsModalEl.current, MODAL_OPTIONS));
    }, []);

    const close = () => {
        modal.hide();
    };

    const recalculate = () => {
        setRequest(true);
        axios
            .put(props.reclculateUrl)
            .catch((er) => {
                alert('Something went wrong');
            })
            .finally(() => {
                setRequest(false);
                modal.hide();
            });
    };

    return (
        <>
            <Button variant="primary" onClick={() => modal.show()}>
                {$t('Recalculate Totals')}
            </Button>

            <div
                ref={recalculateTotalsModalEl}
                tabIndex="-1"
                aria-hidden="true"
                className="hidden modal__box before:tw-content-[''] before:tw-bg-gray-900/50 before:tw-fixed before:tw-inset-0 before:tw-z-0"
            >
                <div className="modal__container">
                    <div className="modal__inner-container">
                        <ModalHeader title={$t("Confirmation of totals' recalculation")} close={close}></ModalHeader>
                        <div className="tw-rounded-b">
                            <div className="modal__form-container">
                                <p className="modal__msg modal__text-color">
                                    {$t('Are you sure you want to recalculate the totals for the event?')}
                                    <br />
                                    {$t('It can take some time.')}
                                    <br />
                                    {$t('Upon completion, you will receive an email notification.')}
                                </p>
                                <ModalFooter
                                    cancelButtonText={$t('Cancel')}
                                    primaryButtonText={$t('OK')}
                                    onCancel={close}
                                    handleSubmit={recalculate}
                                    isSubmitting={request}
                                ></ModalFooter>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

if (document.getElementById('recalculateEventTotals')) {
    var root = document.getElementById('recalculateEventTotals');
    ReactDOM.render(
        <App>
            <RecalculateTotalButton reclculateUrl={recalculateUrl} />
        </App>,
        root,
    );
}
